import EditAuthorization from './edit'
import { getEnvVariable } from '../../../modules/environmentalList';
const AuthorizationsGrid = {
    "title": "Authorizations",
    "type": "grid",
    "key": "AuthorizationsGrid",
    "gridkey": 'AuthorizationsGrid',
    "name": "AuthorizationsGrid",
    "hasreport": true,
    "addRoute": true,
    "routeParams": { replace: 'authorizations', param: 'Id', routeName: 'id' },
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        load: false,
        allgriddata:null,
        navigateItem: null,
        navigation :null,
        reportOpen: false,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
    },
    sharedValues: ['addOpen', 'editOpen', 'editInfo', 'allgriddata', 'navigateItem', 'navigation', 'loadreportfilter', 'ReportJsonQueryStr', 'reportOpen'],
    aliases: {
        addOpen: 'addOpen',
        editOpen: 'editOpen',
        editInfo: 'editInfo',
        allgriddata: 'allgriddata',
        navigateItem: 'navigateItem',
        navigation: 'navigation',
        reportOpen: 'reportOpen',
        loadreportfilter: 'loadreportfilter',
        ReportJsonQueryStr: 'ReportJsonQueryStr'
    },
    headerProps: {
        title: "Authorizations",
        components: [
              {
                type: 'breadcrumbs',
                items: [
                    { "link": "Dashboard", "tab": 'D', "materialicon": "dashboard", href: getEnvVariable('InternalBasepath'), className: 'breadcrumb-item text-dark', class: 'text-dark' },
                    { "link": "Authorization", "materialicon": "vpn_key", className: 'breadcrumb-item ', class: '', color:'#074078' }

                ],
            }
        ],
        actions: [
            {
                type: 'fab',
                icon: 'clear',
                name: 'clear',
                color: 'primary',
                title: 'Clear Filters',
                menucolor: '#22a9b3',
                hideon: 'clear',
                hidevalue: false
            },

            {
                type: 'menu',
                icon: 'excel',
                name: 'excel',
                color: 'primary',
                title: 'Export to Excel',
                menucolor: '#c90685',
                hideon: 'excel',
                hidevalue: false,
                items: [{
                    name: 'Export Current Page',
                    action: 'filtercurrent'
                },
                {
                    name: 'Export All Pages',
                    action: 'filterall'
                }
                ]
            },
              {
                type: 'fab',
                icon: 'reports',
                name: 'reports',
                color: 'primary',
                title: 'Save Report',
                menucolor: '#C85A54',
                hideon: 'reports',
                hidevalue: false
            },
        ]
    },
    "columns": [
        {
            "title": "First Name",
            "field": "FirstName", 
            "show": true,
            "width": 40,
        },
        {
            "title": "Last Name",
            "field": "LastName",
            "show": true,
            "width": 40,
        },
        {
            "title": "Email",
            "field": "Email",
            "show": true,
            "width": 60,
        },
        {
            "title": "Status",
            "field": "IsApprovedDesc",
            "show": true,
            "width": 60,
        },
        {
            "title": "Created On",
            "field": "CreatedOn",
            "show": true,
            "width": 40,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
        },
        
        {
            "title": "Updated On",
            "field": "UpdatedOn",
            "show": true,
            "width": 40,
            filter: "date",
            format: "{0:d}",
            convert: "MM/DD/YYYY hh:mm:ss A"
    },

    ],
    displayName:  'editInfo',
    allgriddata: 'allgriddata',
    navigateItem: 'navigateItem',
    navigation: 'navigation',
    loadreportfilter: 'loadreportfilter',
    ReportJsonQueryStr: 'ReportJsonQueryStr',
    mapActionsToEffects: {
        load: {
            rules: [{
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                 url: getEnvVariable('MasterAdmin')+`/api/IPUsersAuthorizations/GetRequests/Grid?`,
                                //"url":"http://localhost:6004/api/IPUsersAuthorizations/GetRequests/Grid?",
                                "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]// 1 intital load
        },
        addOpen:{
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "addOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                url: getEnvVariable('MasterAdmin')+`/api/IPUsersAuthorizations/GetRequests/Grid?`,
                                //"url":"http://localhost:6004/api/IPUsersAuthorizations/GetRequests/Grid?",
                                "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },
        editOpen:{
            rules: [{
                check: [
                    {
                        condition: 'AND',
                        rules: [
                            {
                                "name": "editOpen",
                                "type": "!=",
                                "value": true,
                                "rules": []
                            }
                        ]
                    }
                ],
                run: {
                    valid: [{
                        type: 'grid',
                        "read": [
                            {
                                 url: getEnvVariable('MasterAdmin')+`/api/IPUsersAuthorizations/GetRequests/Grid?`,
                                 //"url":"http://localhost:6004/api/IPUsersAuthorizations/GetRequests/Grid?",
                                 "matchProps": [{
                                    name: "routeid1",
                                    key: "routeid1",
                                }],
                                type: 'get',
                                saveAs: {
                                    key: 'data'
                                }
                            }
                        ]
                    },
                    ]
                }
            }]
        },
   
        'display': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'editOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'editInfo',
                            },
                            {
                                type: 'resultvalue',
                                name: 'allgriddata',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigateItem',
                            },
                            {
                                type: 'resultvalue',
                                name: 'navigation',
                            },

                        ]
                    }
                }
            ]
        },
        'report': {
            rules: [
                {
                    run: {
                        valid: [
                            {
                                type: 'value',
                                key: 'reportOpen',
                                result: true
                            },
                            {
                                type: 'resultvalue',
                                name: 'loadreportfilter',
                            },
                            {
                                type: 'resultvalue',
                                name: 'ReportJsonQueryStr',
                            },

                        ]
                    }
                }
            ]
        },
    }



}

const AuthorizationsReport = {
    type: 'popup',
    key: 'AuthorizationsReport',
    name: 'AuthorizationsReport',

    anchor: 'right',
    open: false,
    aliases: {
        open: 'reportOpen'
    },
    sharedValues: ['open', 'loadreportfilter', 'ReportJsonQueryStr'],
    container: {
        values: {
            loadreportfilter: null,
            ReportJsonQueryStr: null
        },
        mapValues: {
            Report: [
                {
                    key: 'ReportJsonQueryStr',
                    name: 'ReportJsonQueryStr'
                },
                {
                    key: 'loadreportfilter',
                    name: 'loadreportfilter'
                },
            ],
        },
        mapActionsToEffects: {},
        layout: {
            group: [
                {
                    order: 0,
                    type: 'div',
                    className: '',
                    components: [
                        {
                            name: 'Report'
                        },
                    ]
                }
            ]

        },
        components: {
            Report: {
                "type": "form",
                "key": "Report",
                "name": "Report",
                aliases: {

                },
                sharedValues: ['ReportJsonQueryStr', 'loadreportfilter'],
                values: {
                    loadreportfilter: null,
                    ReportJsonQueryStr: null
                },
                mapActionsToEffects: {},
                layout: {
                    group: [
                        {
                            order: 0,
                            type: 'div',
                            className: '',
                            components: [{
                                name: 'ReportJsonQueryStr',
                                type: 'div',

                            },
                            {
                                name: 'loadreportfilter',
                                type: 'div',

                            }],

                        },
                    ],
                },
                "components": {
                    "ReportJsonQueryStr": {
                        "type": "gridreport",
                        "gridkey": 'AuthorizationsGrid',
                    },
                },
            }
        }
    }
}

const AuthorizationsContainer = {
    type: 'container',
    key: 'AuthorizationsContainer',
    values: {
        addOpen: false,
        editOpen: false,
        editInfo: null,
        allgriddata: null,
        navigateItem: null,
        navigation :null,
        loadreportfilter: null,
        ReportJsonQueryStr: null,
        reportOpen : false,
    },
    mapValues: {
  
        EditAuthorization: [
            {
                key: 'editOpen',
                name: 'open'
            },
            {
                key: 'editInfo',
                name: 'editInfo'
            },
            {
                key: 'allgriddata',
                name: 'allgriddata'
            },
            {
                key: 'navigateItem',
                name: 'navigateItem'
            },
            {
                key: 'navigation',
                name: 'navigation'
            },
        ],
        AuthorizationsGrid: [
            {
                key: 'editOpen',
                name: 'editOpen'
            },
            {
                key: 'reportOpen',
                name: 'reportOpen'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
        ],
        AuthorizationsReport: [
            {
                key: 'reportOpen',
                name: 'open'
            },
            {
                key: 'loadreportfilter',
                name: 'loadreportfilter'
            },
            {
                key: 'ReportJsonQueryStr',
                name: 'ReportJsonQueryStr'
            },

        ]

    },
    mapActionsToEffects: {
      
        'editOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "editOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck:true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'EditAuthorization',
                            }

                        ],
                        inValid:[
                            {
                                type: 'addlayout',
                                name: 'EditAuthorization',
                            }
                        ]
                    }
                }
            ]
        },
        'reportOpen': {
            rules: [
                {
                    check: [
                        {
                            condition: 'AND',
                            rules: [
                                {
                                    "name": "reportOpen",
                                    "type": "!=",
                                    "value": true,
                                    "rules": []
                                }
                            ]
                        }
                    ],
                    uncheck: true,
                    run: {
                        valid: [
                            {
                                type: 'removelayout',
                                name: 'AuthorizationsReport',
                            }

                        ],
                        inValid: [
                            {
                                type: 'addlayout',
                                name: 'AuthorizationsReport',
                            }
                        ]
                    }
                }
            ]
        },
    },
    layout: {
        group: [
            {
                order: 0,
                type: 'div',
                className: 'col-12',
                components: [
                    {
                        name: 'AuthorizationsGrid'
                    },
                ]
            }
        ]

    },
    components: {
        AuthorizationsGrid: AuthorizationsGrid,
        EditAuthorization: EditAuthorization,
        AuthorizationsReport:AuthorizationsReport
    }
}


export default AuthorizationsContainer

